import type {
  LaApplicationType,
  LaLedger,
  LaLedgerApplicationType,
  LeaseHistoryProcessing,
  ListInquirySearchMethod,
} from '@libs/enums';
import type { ItemAttributes, ItemNames, OrEmpty } from '@ps-smart-cp/ppfw-client';
import { ItemName, Locale, SingleValue, ValueSet } from '@ps-smart-cp/ppfw-client';

/**
 * リース情報
 */
interface Schema {
  /**
   * 履歴処理区分
   */
  historyProcessClass: OrEmpty<LeaseHistoryProcessing>;
  /**
   * 申請種類
   */
  applyCategory: LaLedgerApplicationType;
  /**
   * 申請種類(抽出条件)
   */
  applyCategoryCondition: Set<LaLedgerApplicationType>;
  /**
   * 台帳種別
   */
  ledgerClass: OrEmpty<LaLedger>;
  /**
   * 登録内訳
   */
  registrationBreakdown: OrEmpty<LaApplicationType>;

  /**
   * 一覧照会検索条件
   */
  listInquirySearchCondition: ListInquirySearchMethod;
}

const attributes = {
  historyProcessClass: SingleValue.shortValue(),
  applyCategory: ValueSet.new(),
  applyCategoryCondition: ValueSet.new(),
  ledgerClass: SingleValue.longValue(true),
  listInquirySearchCondition: SingleValue.longValue(),
} satisfies ItemAttributes<Schema>;

interface Record {
  historyProcessClass: string;
  applyCategoryCondition: string[];
  applyCategory: string;
  ledgerClass: string;
  registrationBreakdown: string;
  listInquirySearchCondition: string;
}

const names = {
  historyProcessClass: ItemName.of([Locale.ja, '履歴処理区分'], [Locale.en, 'History Process Class']),
  applyCategory: ItemName.of([Locale.ja, '申請種類'], [Locale.en, 'Apply Category']),
  applyCategoryCondition: ItemName.of([Locale.ja, '申請種類'], [Locale.en, 'Apply Category Condition']),
  ledgerClass: ItemName.of([Locale.ja, '台帳種別'], [Locale.en, 'Ledger Class']),
  registrationBreakdown: ItemName.of([Locale.ja, '登録内訳']),
} satisfies ItemNames<Schema>;

const labelNames = {
  targetContract: ItemName.of([Locale.ja, '対象の契約']),
  targetArticle: ItemName.of([Locale.ja, '対象の物件']),
};

const la = {
  names,
  labelNames,
  attributes,
};

interface La {
  schema: Schema;
  record: Record;
}

export { la };
export type { La };
